import { orchestrator } from 'satcheljs';
import { sendLocalizedTextMessage } from '../actions/sendLocalizedTextMessage';
import { logUsage } from 'owa-analytics';
import sendLocalizedSms from '../services/sendLocalizedSms';
import { setPhoneAppCardErrorState } from '../mutators/setPhoneAppCardErrorState';
import { PhoneAppCardErrorState } from '../store/schema/PhoneAppCardState';
import { getMobileContainerName } from '../utils/getMobileContainerName';

orchestrator(sendLocalizedTextMessage, async actionParams => {
    let sendSmsEventName = 'PhoneCardSendLocSMS';

    let response = await sendLocalizedSms({
        sendTo: actionParams.phoneNumber,
        coid: actionParams.coid,
        countryCode: actionParams.countryCode,
    });

    if (response.Success != 'true') {
        sendSmsEventName = 'PhoneCardSendLocSMSFailed';
        setPhoneAppCardErrorState(PhoneAppCardErrorState.Failure);
    } else {
        setPhoneAppCardErrorState(PhoneAppCardErrorState.Success);
    }

    logUsage(
        sendSmsEventName,
        {
            containerName: getMobileContainerName(actionParams.containerName),
            country: actionParams.countryCode,
            coid: response.Coid,
        },
        { isCore: true }
    );
});
